import React, { useEffect, useState } from "react";
import ProzoDataGrid from "../../../common/ProzoDataGrid";
import { Box } from "@mui/material";
import { Button, Typography } from "@mui/material";
import { apiConstants, postGeneric } from "../../../common/constants";
import MUIModal from "../../../common/MUIModal";
import AwbLinkCell from "../../../common/AwbLinkCell";
import { getMerchant } from "../../../helpers/ReduxHelpers";
import Loader from "../../../common/Loader";
import { refreshS3SignedUrl } from "../../../helpers/UtilityHelper";
import {  secondaryTextSx, cellStackSx, awbTextSx } from '../list2/cellStyles';
import { FONT, SIZE } from '../../../styles/foundation/typography';


const ApprovedOrders = () => {
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [data, setData] = useState([])
    const [itemModalData, setItemModalData] = useState();
    const [approveModalData, setApproveModalData] = useState();
    const [approveModaOpen, setApproveModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''

    useEffect(() => {
        setIsLoading(true)
        const payload = {
            "andfilter": [
                {
                    "field": "itemData.isRequestPlaced",
                    "operator": "eq",
                    "value": true
                },
                {
                    "field": "merchantOid",
                    "operator": "eq",
                    "value": merchantId
                },
                {
                    "field": "isAutoApprovalOrder",
                    "operator": "eq",
                    "value": false
                },
            ],
            "orfilter": [
                {
                    "field": "itemData.isOrderPlaced",
                    "operator": "eq",
                    "value": true
                },
                {
                    "field": "itemData.approvedItems",
                    "operator": "gt",
                    "value": 0
                }
            ],
            "skipCount": true,
            "controllerFilter": true,
            "excludes": "otp"
        }
        postGeneric(`${apiConstants.RETURN_EXCHANGE_ORDER_LIST}?conditionFlag=Approved&offset=${page * sizePerPage}&limit=${sizePerPage}`, payload).then((res) => {
            setData(res.data?.resultData?.data?.slice().reverse());
            setIsLoading(false)
        }).catch((err) => {
            setIsLoading(false)
            console.log(err);
        })
    }, [page, sizePerPage, merchantId])

    const columns = [
        {
            field: "revAwbNumber",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Reverse AWB Number",
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <AwbLinkCell awb={row?.revAwbNumber} sx={awbTextSx} />
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <Typography sx={secondaryTextSx}>FWD AWB :</Typography>
                            <AwbLinkCell awb={row?.fwdawbNumber} sx={secondaryTextSx} />
                        </Box>
                    </Box>
                )
            },
        },
        {
            field: "courierPartner",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Courier Partner",
            flex: 0.6,
            minWidth: 150,
        },
        {
            field: "shippingLabelId",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Shipping Label ID",
            flex: 1,
            minWidth: 180,
        },
        {
            field: "action",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Action",
            flex: 0.5,
            minWidth: 120,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Button
                        onClick={() => {
                            setApproveModalData(row.item);
                            setItemModalData(row);
                            setApproveModalOpen(true);
                        }}
                        sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', p: 0, minWidth: 0 }}
                    >
                        View Items
                    </Button>
                )
            },
        },
    ]

    return (
        <>
            {isLoading && <Loader />}
            <ProzoDataGrid
                columns={columns}
                autoHeight={true}
                rows={data?.length > 0 ? data?.map((val, index) => ({ ...val, id: index })) : []}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                hideFooterPagination={false}
                rowCount={Number.MAX_VALUE}
                // rowCount={dataCount ? dataCount : Number.MAX_VALUE}
                getRowId={(row) => row.id}
            />
            <MUIModal title='Approved Items' open={approveModaOpen} handleClose={() => setApproveModalOpen(false)} children={<ApproveDataList approveModalData={approveModalData} itemModalData={itemModalData} />} />
        </>
    );
};

export default ApprovedOrders


const ApproveDataList = ({ approveModalData }) => {

    const columns = [
        {
            field: "item",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Name",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
                const { row } = params;
                return row?.item_name;
            },
        },
        {
            field: "sku_id",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "SKU ID",
            flex: 0.5,
            minWidth: 120,
            renderCell: ({ row }) => {
                return row?.sku_id;
            },
        },
        {
            field: "units",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Approved Units",
            flex: 0.5,
            minWidth: 120,
            renderCell: ({ row }) => {
                return row?.units
            }
        },
        {
            field: "returnImagesUrl",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Return Image",
            flex: 0.5,
            minWidth: 120,
            renderCell: ({ row }) => {
                return (
                    <Typography
                        sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={() => handleView(row?.rvpImgUrl)}
                    >
                        View
                    </Typography>
                );
            },
        },
    ];

    const handleView = async (url) => {
        const refreshedUrl = await refreshS3SignedUrl(url);
        window.open(refreshedUrl, '_blank');
    };

    return (
        <ProzoDataGrid
            columns={columns}
            autoHeight={true}
            rows={approveModalData.map((val, index) => ({ ...val, id: index }))}
            // sizePerPage={sizePerPage}
            // setSizePerPage={setSizePerPage}
            // setPage={setPage}
            // page={page}
            hideFooterPagination
            rowCount={Number.MAX_VALUE}
            getRowId={(row) => row.id}
        />
    )
}
